import { decorate, observable, action, computed } from 'mobx';

class BaseStore {
    constructor(appStore) {
        this.appStore = appStore;
    }

    setData(data) {
        if (!this.hotReloadData) { // todo check environment.. do only if it is development.
            this.hotReloadData = data; //for hotreload
        } else {
            this.hotReloadData = { ...this.hotReloadData, ...data }
        }

        Object.keys(data).forEach(key => {
            this[key] = data[key];
        });
    }

    getHotReloadData() {
        return JSON.parse(JSON.stringify(this.hotReloadData || {}));
    }
}

decorate(BaseStore, {
    hotReloadData: observable,
});
export default BaseStore;